import React from 'react';
import Section, { FadeIn } from './ui/Section';
import SafeIcon from '../common/SafeIcon';

const testimonials = [
  {
    quote: "Just the 'I'm fine' translation changed how my husband and I fight. I stopped chasing, he started opening up. Free guide, massive impact.",
    author: "Sarah, 34",
    icon: "Heart"
  },
  {
    quote: "I almost replied to a 3 AM 'I miss you' before reading this. Saved myself months of confusion.",
    author: "Emma, 26",
    icon: "Clock"
  },
  {
    quote: "The 'do what you want' translation was my whole marriage. I finally understand why we kept fighting about dinner.",
    author: "Marcus, 41",
    icon: "Coffee"
  },
  {
    quote: "As a therapist, I share this with every couple. Immediate, practical, usable tonight.",
    author: "Dr. Sarah Chen, LMFT",
    icon: "Award"
  }
];

const SocialProof = () => {
  return (
    <Section dark>
      <div className="max-w-4xl mx-auto text-center mb-16">
        <FadeIn>
          <h2 className="text-3xl md:text-5xl font-bold mb-4">
            10,000+ People Stopped Guessing
          </h2>
          <div className="flex justify-center gap-1 text-brand-yellow mb-4">
            {[1,2,3,4,5].map(i => <SafeIcon key={i} name="Star" className="fill-current" />)}
          </div>
        </FadeIn>
      </div>

      <div className="grid md:grid-cols-2 gap-6 max-w-5xl mx-auto">
        {testimonials.map((t, i) => (
          <FadeIn key={i} delay={i * 0.1}>
            <div className="bg-white/5 border border-white/10 p-8 rounded-2xl h-full flex flex-col justify-between hover:bg-white/10 transition-colors">
              <div>
                <SafeIcon name={t.icon} className="text-brand-yellow w-8 h-8 mb-6 opacity-80" />
                <p className="text-lg md:text-xl font-light italic leading-relaxed mb-8 text-gray-300">
                  "{t.quote}"
                </p>
              </div>
              <p className="font-bold text-brand-white">— {t.author}</p>
            </div>
          </FadeIn>
        ))}
      </div>
    </Section>
  );
};

export default SocialProof;